import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * Apple Podcasts icon.
 */
const ApplePodcasts = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    {...props}
    className={cn('w-full', props.className)}
  >
    <linearGradient
      id="a"
      x1={20.098}
      x2={20.098}
      y1={7.418}
      y2={32.581}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#f452ff" />
      <stop offset={1} stopColor="#832bc1" />
    </linearGradient>
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M32.182 29.228c-.245.621-.809 1.496-1.61 2.112a5.27 5.27 0 0 1-1.77.921c-.809.24-1.804.32-3.042.32H14.437c-1.239 0-2.234-.08-3.042-.32a5.272 5.272 0 0 1-1.771-.92c-.8-.617-1.365-1.492-1.61-2.113-.492-1.252-.497-2.672-.497-3.567V14.338c0-.894.005-2.315.497-3.566.245-.622.81-1.497 1.61-2.113a5.27 5.27 0 0 1 1.771-.92c.808-.24 1.803-.32 3.042-.32H25.76c1.238 0 2.233.08 3.041.32.758.224 1.31.564 1.772.92.8.616 1.365 1.491 1.61 2.112.492 1.252.497 2.673.497 3.567v11.324c0 .894-.005 2.314-.498 3.566z"
      clipRule="evenodd"
      transform="translate(-7 -7)"
    />

    <path
      fill="none"
      d="M25.182 22.228c-.245.621-.809 1.496-1.61 2.112a5.27 5.27 0 0 1-1.77.921c-.809.24-1.804.32-3.042.32H7.437c-1.239 0-2.234-.08-3.042-.32a5.272 5.272 0 0 1-1.771-.92c-.8-.617-1.365-1.492-1.61-2.113-.492-1.252-.497-2.672-.497-3.567V7.338c0-.894.005-2.315.497-3.566.245-.622.81-1.497 1.61-2.113A5.27 5.27 0 0 1 4.395.74C5.203.5 6.198.42 7.437.42H18.76c1.238 0 2.233.08 3.041.32.758.224 1.31.564 1.772.92.8.617 1.365 1.491 1.61 2.113.492 1.251.497 2.672.497 3.566v11.323c0 .895-.005 2.315-.498 3.567z"
      clipRule="evenodd"
    />

    <path
      fill="#FFF"
      d="M14.923 14.881c-.377-.398-1.04-.653-1.823-.653-.783 0-1.447.255-1.824.653a1.157 1.157 0 0 0-.334.725c-.064.588-.028 1.094.04 1.903.066.772.19 1.8.354 2.847.115.746.21 1.148.295 1.436.139.467.657.875 1.469.875.81 0 1.33-.408 1.468-.875.086-.288.18-.69.295-1.436a43.03 43.03 0 0 0 .353-2.847c.07-.809.105-1.315.041-1.903a1.157 1.157 0 0 0-.334-.724zm-3.88-3.547a2.06 2.06 0 1 0 4.118 0 2.06 2.06 0 0 0-4.119 0zm2.033-8.127c-4.816.014-8.763 3.921-8.822 8.737-.049 3.901 2.442 7.239 5.919 8.462.084.03.17-.04.157-.129a50.475 50.475 0 0 1-.128-.907.304.304 0 0 0-.18-.24 7.725 7.725 0 0 1-4.636-7.15c.04-4.19 3.462-7.606 7.652-7.64 4.284-.035 7.78 3.44 7.78 7.716a7.726 7.726 0 0 1-4.638 7.075.304.304 0 0 0-.179.24c-.04.3-.082.603-.128.906a.118.118 0 0 0 .157.129c3.444-1.212 5.92-4.497 5.92-8.35 0-4.888-3.983-8.863-8.874-8.849zm-.16 4.06a4.8 4.8 0 0 1 4.985 4.792 4.78 4.78 0 0 1-1.516 3.495.367.367 0 0 0-.115.288c.019.329.012.649-.01 1.01a.117.117 0 0 0 .182.104 5.926 5.926 0 0 0 2.591-4.897 5.934 5.934 0 0 0-6.162-5.924c-3.136.122-5.653 2.708-5.693 5.846a5.925 5.925 0 0 0 2.592 4.975.116.116 0 0 0 .181-.103 8.483 8.483 0 0 1-.01-1.011.367.367 0 0 0-.115-.288 4.783 4.783 0 0 1-1.514-3.624 4.809 4.809 0 0 1 4.604-4.663z"
    />
  </svg>
);

export default ApplePodcasts;
